import type { FC } from 'react'

import { ArrowRightOutline16 } from '@sok/design-system'
import { NextLink } from 'components/NextLink'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useSelectedStoreName } from 'utils/hooks/use-selected-store-name'

const StoreLink = styled(NextLink)(({ theme }) => ({
  ...theme.variants.body1,
  alignItems: 'center',
  color: 'inherit',
  display: 'flex',

  svg: {
    marginLeft: theme.spacings.xxSmall,
  },
}))

const AisleName = styled.p(({ theme }) => ({
  ...theme.variants.body2.medium,
  marginBottom: theme.spacings.xxSmall,
}))

interface ProductLocationTableProps {
  aisle: string
  floor: number | null
  storeId: string
}

export const ProductLocationTable: FC<ProductLocationTableProps> = ({ aisle, floor, storeId }) => {
  const { t } = useTranslation()
  const { storeName } = useSelectedStoreName()

  return (
    <>
      <AisleName>
        {t('Product location info aisle', { aisle: aisle })}{' '}
        {floor && floor > 1
          ? t('Product location info floor', {
              floor: floor,
            })
          : ''}
      </AisleName>
      <StoreLink href={`/myymala/${storeId}`}>
        <span>{storeName}</span> <ArrowRightOutline16 />
      </StoreLink>
    </>
  )
}
